import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom-v5-compat";
import * as yup from "yup";

import { TwoColumnPage, InfoPage, ContentBlock } from "./Atoms";
import { TextField, RadioSelectField, Form, Button } from "./Form";
import { useJourney } from "./sign_up_journeys";

const GoingLiveInfo = () => {
  const { t } = useTranslation();
  return (
    <InfoPage title={t("goingLive.title")}>
      <ContentBlock
        content={[
          <Trans t={t} i18nKey="goingLive.content.0" />,
          <div>
            {t("goingLive.content.1")}
            <ul className="list-disc pl-32">
              <Trans
                i18nKey="goingLive.taskList"
                components={{ li: <li className="" /> }}
              />
            </ul>
          </div>,
          <Trans t={t} i18nKey="goingLive.content.2" />,
        ]}
      />
      <ContentBlock
        subTitle={t("goingLive.needMoreHelp")}
        content={[<Trans t={t} i18nKey="goingLive.itsEasyBut" />]}
      />
    </InfoPage>
  );
};

const schema = yup
  .object({
    goLiveDate: yup.string().label("Go live Date").nullable(),
    hardwareHelp: yup.string().ensure().required("Please select an answer"),
    partnerContact: yup.string().ensure().required("Please select an answer"),
  })
  .required();

const GoingLiveForm = ({}) => {
  const { t } = useTranslation();
  const {
    journey,
    saveJourney,
    formProps: { handleSubmit, ...formProps },
  } = useJourney({ resolver: yupResolver(schema) });

  const navigate = useNavigate();
  const onSubmit = async (data) => {
    await saveJourney(data);
    navigate("../further-questions");
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <h1 className="text-center">{t("formContent.goingLiveTitle")}</h1>
      <input type="hidden" value="going-live" {...formProps("currentPage")} />
      <TextField
        formProps={formProps}
        type="date"
        name="goLiveDate"
        label={t("formContent.goLiveDate")}
        helpText={t("formContent.goLiveDate_helpText")}
      />
      <RadioSelectField
        label={t("formContent.hardwareHelp")}
        name="hardwareHelp"
        options={[
          { value: "yes", label: t("formContent.hardwareHelpNeeded") },
          { value: "no", label: t("formContent.hardwareHelpNotNeeded") },
        ]}
        formProps={formProps}
      />
      <RadioSelectField
        label={t("formContent.contactFromHardwarePartner")}
        helpText={t("formContent.contactFromHardwarePartner_helpText")}
        name="partnerContact"
        options={[
          {
            value: "yes",
            label: t("formContent.yesContactFromHardwarePartner"),
          },
          {
            value: "no",
            label: t("formContent.noContactFromHardwarePartner"),
          },
        ]}
        formProps={formProps}
      />
      <div className="text-center">
        <Button primary>{t("goingLive.nextButton")}</Button>
      </div>
    </Form>
  );
};
const GoingLive = ({ progress }) => {
  return (
    <TwoColumnPage
      progress={progress}
      left={<GoingLiveInfo />}
      right={<GoingLiveForm />}
    />
  );
};

export default GoingLive;
